import {
  EngagementDetailMasterActions,
  EngagementTypeActions,
  EngagementRoleActions,
  EngagementProductActions,
  saveAllEngagementDetailsActions,
} from "./actions";

const initialState = {
  partnerFunctionMasterList: [],
  partnerTypeMasterList: [],
  partnerProductMasterList: [],
  EngagementType: [],
  EngagementRole: [],
  EngagementProduct: [],
  saveAllEngagementDetails: "",
  saveAllError: "",
  saveAllLoading: false,
  error: ""
};

const EngageMentdetailMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case EngagementDetailMasterActions.ENGAGEMENT_DETAILS_MASTER_SUCCESS:
      return {
        ...state,
        ...action.payload,
      };

    case EngagementTypeActions.ENGAGEMENT_TYPE_SUCCESS:
      return {
        ...state,
        EngagementType: action.payload,
      };

    case EngagementRoleActions.ENGAGEMENT_ROLE_SUCCESS:
      return {
        ...state,
        EngagementRole: action.payload,
      };

    case EngagementProductActions.ENGAGEMENT_PRODUCT_SUCCESS:
      return {
        ...state,
        EngagementProduct: action.payload,
      };
    case saveAllEngagementDetailsActions.SAVE_ALL_ENGAGEMENT_DETAILS_SUCCESS:
      return {
        ...state,
        saveAllEngagementDetails: action.payload,
        saveAllLoading: false,
      };

    case saveAllEngagementDetailsActions.SAVE_ALL_ENGAGEMENT_DETAILS_ERROR:
      return {
        ...state,
        saveAllError: action.payload,
        saveAllLoading: false,
      };
    case saveAllEngagementDetailsActions.SAVE_ALL_ENGAGEMENT_DETAILS_LOADING:
      return {
        ...state,
        saveAllLoading: true,
      };

    case EngagementTypeActions.ENGAGEMENT_TYPE_ERROR:
      return {
        ...state,
        EngagementType: [],
        error: action.payload
      };

    case EngagementRoleActions.ENGAGEMENT_ROLE_ERROR:
      return {
        ...state,
        EngagementRole: [],
        error: action.payload,
      };

    case EngagementProductActions.ENGAGEMENT_PRODUCT_ERROR:
      return {
        ...state,
        EngagementProduct: [],
        error: action.payload
      };

    default:
      return state;
  }
};

export default EngageMentdetailMasterReducer;
